import { GET_ZONES, SUCCESS, FAIL } from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isUpdating: false,
  zones: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_ZONES:
      return { ...state, isLoading: true };
    case `${GET_ZONES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        zones: [...payload],
      };
    case `${GET_ZONES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};
